// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2680ed4a","143":"7acc3c81"}[chunkId] + ".chunk.js";
};